<template>
  <div>
    <!-- 面包屑导航 -->

    <el-card class="box-card">
      <div>
        <el-card class="form-card">
          <el-form ref="searchform" v-model="form" label-width="80px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="行业名称">
                  <el-input v-model="form.professionName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="行业编号">
                  <el-input v-model="form.professionCode"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="负责人">
                  <el-input v-model="form.brdOwner"></el-input>
                </el-form-item>
              </el-col>-->
              <el-col :span="6">
                <el-form-item label="激活状态">
                  <el-select v-model="form.actFlag">
                    <el-option label="不限" value></el-option>
                    <el-option label="启用" value="T"></el-option>
                    <el-option label="禁用" value="F"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item>
                  <el-button @click="dialogFormVisible = true">新增</el-button>
                  <el-button type="primary" @click="onSubmit">搜索</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
    </el-card>

    <el-table :data="BrandList" v-loading="loading" :show-overflow-tooltip="true" border stripe style="width: 100%" height="500">
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column prop="brdName" label="行业名称" show-overflow-tooltip min-width="110px"></el-table-column>
      <el-table-column prop="brdCode" label="行业编号" min-width="90px"></el-table-column>

      <el-table-column prop="created_at" label="创建" show-overflow-tooltip min-width="160px">
        <template slot-scope="scope">
          <el-row>{{scope.row.created_at}}</el-row>
          <el-row>{{scope.row.created_user}}</el-row>
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="更新" show-overflow-tooltip min-width="120px">
        <template slot-scope="scope">
          <el-row>{{scope.row.updated_at}}</el-row>
          <el-row>{{scope.row.updated_user}}</el-row>
        </template>
      </el-table-column>
      <el-table-column prop="actFlag" label="激活状态" width="90px">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.actFlag" active-color="#13ce66" inactive-color="#ff4949" active-value="T" inactive-value="F" @change="chageAct(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140px">
        <template slot-scope="scope">
          <!-- 编辑 -->
          <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDilog(scope.row)"></el-button>
          </el-tooltip>

          <!-- 删除 -->
          <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="delBrand(scope.row.id)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog title="新增行业" :visible.sync="dialogFormVisible" width="50%" @close="addDilogClosed" :close-on-click-modal="false">
      <el-form :model="addform" ref="addformRef" size="mini">
        <el-form-item label="行业名称" prop="professionName" :label-width="formLabelWidth">
          <el-input v-model="addform.professionName" autocomplete="on" style="width:50%" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="行业编号" prop="professionCode" :label-width="formLabelWidth">
          <el-input v-model="addform.professionCode" autocomplete="on" style="width:50%" maxlength="20"></el-input>
        </el-form-item>
        <!-- <el-form-item label="负责人" prop="brdOwner" :label-width="formLabelWidth">
          <el-input v-model="addform.brdOwner" autocomplete="on" style="width:50%" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="ownerTel" :label-width="formLabelWidth">
          <el-input v-model="addform.ownerTel" autocomplete="on" style="width:50%" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="ownerEmail" :label-width="formLabelWidth">
          <el-input v-model="addform.ownerEmail" autocomplete="on" style="width:50%" maxlength="32"></el-input>
        </el-form-item>-->
        <el-form-item label="激活状态" prop="actFlag" :label-width="formLabelWidth">
          <el-radio-group v-model="addform.actFlag">
            <el-radio label="T">启用</el-radio>
            <el-radio label="F">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="addform.memo" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addBrand">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑行业" :visible.sync="editdialogFormVisible" width="50%" @close="editDilogClosed" :close-on-click-modal="false">
      <!-- <el-form :model="editform" ref="editformRef" size="mini" >
        <el-form-item label="行业名称" prop="brdName" :label-width="formLabelWidth">
          <el-input v-model="editform.brdName" autocomplete="on" style="width:50%" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="行业编号" prop="brdCode" :label-width="formLabelWidth">
          <el-input v-model="editform.brdCode" autocomplete="on" style="width:50%" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="brdOwner" :label-width="formLabelWidth">
          <el-input v-model="editform.brdOwner" autocomplete="on" style="width:50%" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="ownerTel" :label-width="formLabelWidth">
          <el-input v-model="editform.ownerTel" autocomplete="on" style="width:50%" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="ownerEmail" :label-width="formLabelWidth">
          <el-input v-model="editform.ownerEmail" autocomplete="on" style="width:50%" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="激活状态" prop="actFlag" :label-width="formLabelWidth">
          <el-radio-group v-model="editform.actFlag">
            <el-radio label="T">启用</el-radio>
            <el-radio label="F">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="editform.memo" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
      </el-form>-->
      <el-form :model="editform" ref="editformRef" size="mini">
        <el-form-item label="行业名称" prop="professionName" :label-width="formLabelWidth">
          <el-input v-model="addform.professionName" autocomplete="on" style="width:50%" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="行业编号" prop="professionCode" :label-width="formLabelWidth">
          <el-input v-model="addform.professionCode" autocomplete="on" style="width:50%" maxlength="20"></el-input>
        </el-form-item>
        <!-- <el-form-item label="负责人" prop="brdOwner" :label-width="formLabelWidth">
          <el-input v-model="addform.brdOwner" autocomplete="on" style="width:50%" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="ownerTel" :label-width="formLabelWidth">
          <el-input v-model="addform.ownerTel" autocomplete="on" style="width:50%" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="ownerEmail" :label-width="formLabelWidth">
          <el-input v-model="addform.ownerEmail" autocomplete="on" style="width:50%" maxlength="32"></el-input>
        </el-form-item>-->
        <el-form-item label="激活状态" prop="actFlag" :label-width="formLabelWidth">
          <el-radio-group v-model="addform.actFlag">
            <el-radio label="T">启用</el-radio>
            <el-radio label="F">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="addform.memo" autocomplete="on" style="width:50%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="editdialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveBrand">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    // 验证邮箱规则
    var checkEmail = (rule, value, callback) => {
      // 正则表达式
      const regEmail = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z_-])+/;
      if (regEmail.test(value) || !value) {
        return callback();
      }
      callback(new Error("请输入合法的邮箱"));
    };
    // 验证手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^(13[0-9]|15[012356789]|15[012356789]|17[15678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/;

      // 符合规则
      if (regMobile.test(value) || !value) {
        return callback();
      }
      callback(new Error("请输入合法的手机号"));
    };

    return {
      form: {
        // brdName: "",
        // brdCode: "",
        // brdOwner: "",
        // actFlag: "",
      },
      addform: {
        // brdName: "",
        // brdCode: "",
        // brdOwner: "",
        // ownerTel: "",
        // ownerEmail: "",
        // actFlag: "T",
        // memo: "",
      },
      editform: {
        // brdName: "",
        // brdCode: "",
        // brdOwner: "",
        // ownerTel: "",
        // ownerEmail: "",
        // actFlag: "",
        // memo: "",
      },
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 10,
      },
      currentPage: 1,
      total: 0,
      selvalue: "",
      dialogFormVisible: false,
      editdialogFormVisible: false,
      formLabelWidth: "80px",
      rules: {
        brdName: [
          { required: true, message: "请输入行业名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        brdCode: [
          { required: true, message: "请输入行业编号", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        ownerEmail: [{ validator: checkEmail, trigger: "blur" }],
        ownerTel: [{ validator: checkMobile, trigger: "blur" }],
      },
      BrandList: [],
      errmsg: "",
      loading: true,
    };
  },
  methods: {
    // 搜索
    onSubmit() {
      this.queryInfo.pagenum = 1;
      this.currentPage = 1;
      this.queryInfo.query = this.form;
      this.getBrandLists();
    },
    handleSizeChange(val) {
      this.queryInfo.pagesize = val;

      this.getRoleLists();
    },

    handleCurrentChange(val) {
      this.queryInfo.pagenum = val;

      this.getRoleLists();
    },
    // 关闭新增窗口
    addDilogClosed() {
      this.$refs.addformRef.resetFields();
    },
    editDilogClosed() {
      this.$refs.editformRef.resetFields();
    },
    // 新增行业
    async addBrand() {
      // this.$refs.addformRef.validate(async (valid) => {
      //   if (!valid) return;

      this.$http
        .post("addprofession", this.addform)
        .then((response) => {
          this.$message.success("添加行业成功");

          this.dialogFormVisible = false;

          this.getBrandLists();
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
      // });
    },
    // 显示修改用户对话框
    async showEditDilog(row) {
      let copy = Object.assign({}, row);
      this.editform = copy;
      this.editdialogFormVisible = true;
    },
    // 保存编辑行业信息
    saveBrand() {
      // this.$refs.editformRef.validate(async (valid) => {
      //   if (!valid) return;

      this.$http
        .post("editprofession", this.editform)
        .then((response) => {
          const res = response.data;

          this.$message.success("编辑成功");

          this.editdialogFormVisible = false;

          this.getBrandLists();
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
      // });
    },
    // 删除行业
    async delBrand(brdid) {
      // 弹框询问是否删除
      const confirmResult = await this.$confirm(
        "此操作将永久删除该行业, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);

      // 确认删除
      if (confirmResult == "confirm") {
        await this.$http
          .delete("delprofession/" + brdid)
          .then((response) => {
            const res = response.data;

            this.$message.success("删除成功");

            this.getBrandLists();
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message);
          });
      }
    },
    // 变更激活状态
    async chageAct(brandInfo) {
      await this.$http
        .put("actprofession/" + brandInfo.id + "/" + brandInfo.actFlag)
        .then((response) => {
          const res = response.data;

          this.$message.success(res.data);
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
    },
    // 获取行业列表
    async getBrandLists() {
      this.loading = true;
      await this.$http
        .post("professionlists", this.queryInfo)
        .then((response) => {
          const res = response.data;

          this.BrandList = res.data.data;

          this.total = res.data.total;

          this.currentPage = res.data.current_page;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          return this.$message.error(error.response.data.message);
        });
    },
  },
  created() {
    this.getBrandLists();
  },
};
</script>

<style lang="less" scoped>
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.form-card {
  margin-bottom: 15px;
}
.add-card {
  width: 50%;
}
.el-dialog {
  /* 表单页面居中，宽度50% ,legend颜色设置，legend圆角*/
  border: 2px solid #dcdfe6;
  text-align: center;
  border-radius: 8px;
  margin: 0 auto;
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/basic/industry.vue